import { Injectable } from '@angular/core';
import { ConstantConfigService } from '../services/constant-config.service';
import { CookieService } from 'ngx-cookie-service';
import { JwtHelperService } from "@auth0/angular-jwt";
import { Router } from '@angular/router';

const helper = new JwtHelperService();
//const TOKEN_KEY = 'auth-token';
//const USER_KEY = 'auth-user';

@Injectable({
  providedIn: 'root'
})
export class TokenStorageService {
  _baseURL : string;
  _accessToken : string;
  _apiToken : string;
  _guestToken:string;
  _CookieExpireTokenTime;
  
  constructor(
    private cookieService: CookieService,
    private router: Router
  ) {
    this._accessToken = ConstantConfigService.accessToken;
    this._CookieExpireTokenTime = ConstantConfigService.CookieExpireTokenTime;
    this._apiToken = ConstantConfigService.apiToken;
    this._guestToken = ConstantConfigService.guestToken;
   }

  public saveToken(token: string,storecookie=0,CookieExpireTokenTime: number) {
    localStorage.removeItem("free_flow");
    if(typeof token!="undefined" && token!="undefined" && token!="" && token!=null){
      localStorage.setItem(this._accessToken, token);
    }
    if(storecookie == 1 && typeof token!="undefined" && token!="undefined" && token!="" && token!=null){
      this.cookieService.delete(this._accessToken);
      this.cookieService.set(this._accessToken, token,CookieExpireTokenTime);
    }
  }

  public saveRequestToken(apitoken: string) {
    if(typeof apitoken!="undefined" && apitoken!="undefined"){
      localStorage.setItem(this._apiToken, apitoken);
    }
  }

  public getToken(): string {
    return localStorage.getItem(this._accessToken);
  }

  public decodeToken(myToken): any {
    return helper.decodeToken(myToken);
  }

  public getUserInfo(myToken): any {
    return helper.decodeToken(myToken).userdata;
  }
  public saveGuestToken(token: string,storecookie=0,CookieExpireTokenTime: number) {

    if(storecookie == 1 && typeof token!="undefined" && token!="undefined" && token!="" && token!=null){
      var tokenobject = {token: token, timestamp: new Date().getTime()}
      localStorage.removeItem(this._guestToken);
      this.cookieService.delete(this._guestToken,'/');
      this.cookieService.set(this._guestToken, JSON.stringify(tokenobject),CookieExpireTokenTime,'/');
      localStorage.setItem(this._guestToken, JSON.stringify(tokenobject));
    }

    if(typeof token!="undefined" && token!="undefined" && token!="" && token!=null){
      localStorage.removeItem(this._guestToken);
      this.cookieService.delete(this._guestToken,'/');
      var tokenobject = {token: token, timestamp: new Date().getTime()}
      localStorage.setItem(this._guestToken, JSON.stringify(tokenobject));
      this.cookieService.set(this._guestToken, JSON.stringify(tokenobject),CookieExpireTokenTime,'/');
    }
  }

  // Get token with expiration check
  public getValidToken(): string | null {
    const token = localStorage.getItem(this._accessToken);
    
    if (!token || token === "undefined" || token === "") {
      console.log('No token found');
      return null;
    }
    
    // Check if token is expired
    if (this.isTokenExpired(token)) {
      console.log('Token expired - clearing from storage');
      this.clearExpiredToken();
      return null;
    }

    console.log('Token is valid');
    return token;
  }

  // Check if token is expired
  public isTokenExpired(token: string): boolean {
    if (!token) return true;
    
    try {
      return helper.isTokenExpired(token);
    } catch (error) {
      console.error('Error checking token expiration:', error);
      return true;
    }
  }

  // Clear expired token from all storage locations
  private clearExpiredToken(): void {
    localStorage.removeItem(this._accessToken);
    this.cookieService.delete(this._accessToken);
    localStorage.removeItem(this._apiToken);
    localStorage.removeItem("free_flow");
  }

}
